import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useIdentidade } from './ContextoDeIdentidade';

/**
 * Guarda de rota do lado do cliente.
 *
 * Vale dizer o que ela NÃO é: controle de acesso. Isso é do servidor —
 * aqui é só para a pessoa não encarar uma tela vazia sem saber que precisa
 * entrar. O `state.de` preserva para onde ela estava indo.
 */
export function RotaProtegida(): React.JSX.Element {
  const { autenticado, carregando } = useIdentidade();
  const local = useLocation();

  // Enquanto o servidor não disse quem está logado, NÃO redireciona. O
  // cookie é HttpOnly: o front não tem como saber se há sessão sem
  // perguntar, e decidir antes da resposta mandaria para o login toda
  // pessoa que apenas atualizou a página com sessão válida.
  if (carregando) {
    return (
      <Box role="status" aria-live="polite" aria-busy="true" sx={{ display: 'grid', placeItems: 'center', p: 6 }}>
        <CircularProgress aria-label="Verificando sessão" />
      </Box>
    );
  }

  if (!autenticado) {
    return <Navigate to="/entrar" replace state={{ de: `${local.pathname}${local.search}` }} />;
  }
  return <Outlet />;
}
